<template>
  <div id="weather">
    <h2 class="mt-2">Weather</h2>
    <div class="row">

      <!-- Currently -->
      <div class="col-sm-5">
        <div class="card">
          <div class="card-body">
            <div class="card-icon large">
              <!-- <canvas id="icon1" width="120" height="120"></canvas> -->
              <skycon :condition="weather.data.message.currently.icon" :width="100" :height="100" />
            </div><!-- /.card-icon -->
            <div class="card-title">
              <p>Currently - {{ weather.data.message.currently.time | moment("LT") }}</p>
            </div><!-- /.card-title -->
            <div class="card-figure">
              {{ weather.data.message.currently.temperature | toInteger }}°F
            </div><!-- /.card-figure -->
            <div class="card-figure-label">
              {{ weather.data.message.currently.summary }}
            </div><!-- /..card-figure-label -->
            <div class="card-figure-label">
              <strong>Wind:</strong> {{ weather.data.message.currently.windSpeed }} mph
            </div><!-- /..card-figure-label -->
            <div class="card-figure-label">
              <strong>Gusting:</strong> {{ weather.data.message.currently.windGust }} mph
            </div><!-- /..card-figure-label -->
          </div><!-- /.card-body -->
        </div>
      </div><!-- /.col-sm-5 -->

      <!-- Today -->
      <div class="col-sm-7">
        <div class="card">
          <div class="card-body">
            <div class="card-icon">
              <skycon :condition="weather.data.message.hourly.icon" :width="100" :height="100" />
            </div><!-- /.card-icon -->
            <div class="card-title">
              <p>Today</p>
            </div><!-- /.card-title -->
            <div class="card-figure">
              {{ weather.data.message.daily.data[0].temperatureMax | toInteger }} / {{ weather.data.message.daily.data[0].temperatureMin | toInteger }}°F
            </div>
            <div class="row">
              <div class="col">
                <p class="card-figure-label"><strong>Wind:</strong> {{ weather.data.message.daily.data[0].windSpeed }} mph<br>
                <strong>Gusts:</strong> {{ weather.data.message.daily.data[0].windGust }} mph<br>
                <strong>Humidity:</strong> {{ weather.data.message.daily.data[0].humidity * 100 }}%</p>
              </div><!-- /.col -->
              <div class="col">
                <p class="card-figure-label"><strong>Sunrise:</strong> {{ weather.data.message.daily.data[0].sunriseTime | moment("LT") }}<br>
                <strong>Sunset:</strong> {{ weather.data.message.daily.data[0].sunsetTime | moment("LT") }}</p>
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div><!-- /.card-body -->
        </div>
      </div><!-- /.col-sm-6 -->

    </div><!-- /.row -->

    <!-- HOURLY -->
    <!-- <div class="row mt-2">
      <div class="col-md-12">
        <div class="card" style="text-align:center;">
          <div class="card-body">
            <div class="card-title">
              <p>Hourly</p>
            </div>
            <div class="row">
              <div
                v-for="(hour, index) in weather.data.message.hourly.data"
                v-if="index > 0 && index < 8"
                class="col week-days"
              >
                <skycon :condition="hour.icon" :width="50" :height="50" />
                <p class="lead">{{ hour.time | moment("h a") }}</p>
                <p><strong>{{ hour.temperature | toInteger }}°F</strong></p>
              </div>
            </div>
            <button
              @click="extendedHours = true"
              class="btn btn-outline-dark"
            >More Hours</button>
            <div
              v-if="extendedHours == true"
              class="calendar-popup"
            >
              <div class="calendar-popup-content">
                <div class="clickable calendar-popup-close"
                  @click="extendedHours = false"
                ><i class="fas fa-times"></i></div>
                <h2>24 Hours</h2>

                <div
                  v-for="(hour, index) in weather.data.message.hourly.data"
                  v-if="index > 0 && index < 24"
                >
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3">
                          <skycon :condition="hour.icon" :width="80" :height="80" />
                          <h2>{{ hour.time | moment("h a") }}</h2>
                          <h3>{{ hour.temperature | toInteger }}°F</h3>
                        </div>
                        <div class="col-md-9">
                          <p>Humidity: {{ hour.humidity }}</p>
                          <p>Wind Speed: {{ hour.windSpeed }}</p>
                          <p>Gusting: {{ hour.windGust }}</p>
                          <p>Cloud Cover: {{ hour.cloudCover }}</p>
                          <p>Chance of Precipitation: {{ hour.precipProbability * 100 }}%</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->
    <!-- END HOURLY BLOCK -->

    <!-- OUTLOOK -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card" id="extended-forecast">
          <div class="card-body">
            <div class="card-title">
              <p>Outlook</p>
            </div><!-- /.card-title -->
            <p class="card-figure-label">{{ weather.data.message.daily.summary }}</p>
            <div class="row">
              <div
                v-for="(day, index) in weather.data.message.daily.data"
                v-if="index > 0"
                class="col week-days"
              >
                <skycon :condition="day.icon" :width="50" :height="50" />
                <p>{{ day.time | moment("dddd") }}</p>
                <p>{{ day.temperatureMax | toInteger }} / {{ day.temperatureMin | toInteger }}°F</p>
              </div>
            </div><!-- /.row -->
            <!-- Weather page links -->
            <div
              v-if="dashboard.data.modules.weather.links"
            >
              <a
                v-for="link in dashboard.data.modules.weather.links"
                :href="link.url"
                target="_blank"
                class="btn btn-outline-dark mr-1"
              >
                {{ link.text }}
              </a>
            </div><!-- /v-if links -->
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-12 -->
    </div>





  </div><!-- /#weather -->
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        weather: {},
        extendedHours: false
      }
    },
    computed: {
      ...mapState(['dashboard'])
    },
    mounted() {
      this.getWeather()
    },
    methods: {
      getWeather() {
        let self = this
        setTimeout(function() {
          let timeStamp = new Date().getTime()
          let lng = self.dashboard.data.modules.weather.lng
          let lat = self.dashboard.data.modules.weather.lat
          axios
            .get('https://us-central1-hospitality-dashboard.cloudfunctions.net/getWeather?lng=' + lng + '&lat=' + lat + '&timestamp=' + timeStamp)
            .then(response => {
              self.weather = response
            })
        }, 1000)
      }
    },
    filters: {
      toInteger(value) {
        return value.toFixed(0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Weather.vue